import { render, staticRenderFns } from "./PracticeDetailsCard.vue?vue&type=template&id=0747254e"
import script from "./PracticeDetailsCard.vue?vue&type=script&lang=js"
export * from "./PracticeDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports